module.exports = __webpack_public_path__ + "img/拓疆者.5b8ed73f.png";